import { useMutation, useQueryClient } from '@tanstack/react-query';

import { accountKeys } from '~teacher/hook/account';

import { leaveTeam } from '../../../api/teams/leaveTeam';
import { teamsKeys } from './teamsKeys';

export function useLeaveTeam() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: leaveTeam,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [teamsKeys.all, accountKeys.account],
      });

      return window.location.reload();
    },
  });
}
